// シーン横断のイベントバス
import Phaser from 'phaser';

export interface GameEvents {
  'player-hp': { hp: number; maxHp: number };
  'player-died': undefined;
  'enemy-killed': { x: number; y: number };
  'chest-opened': { itemKey: string };
  'boss-defeated': undefined;
}

class TypedBus {
  private emitter = new Phaser.Events.EventEmitter();

  emit<K extends keyof GameEvents>(key: K, payload: GameEvents[K]): void {
    this.emitter.emit(key, payload);
  }

  on<K extends keyof GameEvents>(key: K, fn: (payload: GameEvents[K]) => void): void {
    this.emitter.on(key, fn);
  }

  off<K extends keyof GameEvents>(key: K, fn: (payload: GameEvents[K]) => void): void {
    this.emitter.off(key, fn);
  }

  removeAllListeners(): void {
    this.emitter.removeAllListeners();
  }
}

export const bus = new TypedBus();
